import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmButtonComponent } from './confirm-button.component';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faTimes} from '@fortawesome/pro-light-svg-icons';
import {TranslocoModule} from '@ngneat/transloco';

@NgModule({
  declarations: [
    ConfirmButtonComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    TranslocoModule
  ],
  exports: [
    ConfirmButtonComponent
  ]
})
export class ConfirmButtonModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faTimes)
  }
}
